import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { GoVerified, GoVersions } from "react-icons/go";
import { IsMobileEnv } from '../../configurations/initUrls';
import QRScanner from '../../configurations/native/QRScanner';

const FabToggle = () => {
    const [open, setOpen] = useState(false)
    return (
        <div className="fixed bottom-6 right-6 flex flex-col items-end space-y-2 z-50">
            {/* Action Buttons */}
            <div className={`flex flex-col items-end space-y-2 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                {IsMobileEnv &&
                    <QRScanner setOpen={setOpen} />
                }
                <Link to="/checkregister" className="transition-all duration-300 flex gap-2 item-center justify-center">
                    <span className='my-auto shadow-2xl px-3 py-1 bg-blue-400 hover:bg-blue-500 text-white rounded-lg'>
                        Check Registered
                    </span>
                    <div className='bg-blue-400 hover:bg-blue-500 text-white p-4 rounded-full shadow-2xl '>
                        <GoVersions size={20} />
                    </div>
                </Link>
                <Link to="/checkconfirmed" className="transition-all duration-300 flex gap-2 item-center justify-center">
                    <span className='my-auto shadow-2xl px-3 py-1 bg-green-400 hover:bg-green-500 text-white rounded-lg'>
                        Check Confirmed
                    </span>
                    <div className='bg-green-400 hover:bg-green-500 text-white p-4 rounded-full shadow-2xl '>
                        <GoVerified size={20} />
                    </div>
                </Link>
            </div>
            {/* Main FAB */}
            <button
                onClick={() => setOpen(!open)}
                className={`${open ? "bg-red-400 hover:bg-red-500" : "bg-sky-500 hover:bg-sky-600"} text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-transform duration-300`}
            >
                <FiPlus size={24} className={`transform transition-transform duration-300 ${open ? 'rotate-45' : ''}`} />
            </button>
        </div>
    );
};

export default FabToggle;
